import cc from 'classcat';
import { useRef } from 'react';
import { preventDefault } from '@i-ark/utils';
import { Tooltip } from '@ui/kit';
import { useShortcut } from '../hook.use-shortcut.js';
import { buttonCls } from './atom.button.style.js';
import { jsx } from 'react/jsx-runtime';

/* eslint-disable react-hooks/rules-of-hooks */
const Button = ({
  tooltip,
  forceTooltipEnabled,
  shortcut,
  activated,
  onClick,
  children,
  buttonRef,
  ...buttonProps
}) => {
  const ref = buttonRef ?? useRef(null);
  if (onClick !== undefined && shortcut !== undefined) {
    useShortcut(shortcut, onClick);
  }
  const handleClick = evt => {
    if (onClick !== undefined) {
      onClick(evt);
    }
    evt.stopPropagation();
  };
  const handleMouseDown = preventDefault;
  const handleTouchStart = preventDefault;
  return /*#__PURE__*/jsx(Tooltip, {
    containerRef: ref,
    placement: "bottom",
    shortcut: shortcut,
    body: tooltip,
    ariaType: "description",
    disabled: buttonProps.disabled === true && forceTooltipEnabled !== true,
    children: ref => /*#__PURE__*/jsx("button", {
      ...buttonProps,
      ref: ref,
      className: cc([buttonCls, buttonProps.className, {
        activated
      }]),
      onMouseDown: handleMouseDown,
      onTouchStart: handleTouchStart,
      onClick: handleClick,
      children: children
    })
  });
};

export { Button };
//# sourceMappingURL=atom.button.js.map
